import {DeliveryZone, OrderStatus,} from "@/gql/gen";
import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {useScopeQuery} from "@/core/store/scopeQuery";

const STORE_NAME = "shop";

export const useShopStore = defineStore(STORE_NAME, () => {

    const {registerScopeQuery} = useScopeQuery();

    const orderStatuses = ref<OrderStatus[]>([]);
    const deliveryZones = ref<DeliveryZone[]>([]);

    const comp = computed(() => {
    })

    // SCOPE QUERY
    registerScopeQuery(
        STORE_NAME,
        "app",
        {
            sale_order_statuses: {
                __fragment: "OrderStatus",
            },
            sale_delivery_zones: {
                __fragment: "DeliveryZone",
            },

        },
        (data) => {
            if (data.sale_order_statuses)
                orderStatuses.value = data.sale_order_statuses;
            if (data.sale_delivery_zones)
                deliveryZones.value = data.sale_delivery_zones;

        }
    );

    const orderStatusesOrder = computed(() => {
        return orderStatuses.value.filter(status => status.TYPE === 'O')
    })

    return {
        comp,
        orderStatuses,
        deliveryZones,
        orderStatusesOrder,
    };
});



